module.exports = __webpack_public_path__ + "img/img_innovation2.aeb33176.png";